import React from "react";
import { Button } from "@components/atoms/buttons/button/button";
import closeIcon from "@src/assets/svg/close-icon.svg";
import backArrowIcon from "@src/assets/svg/back-arrow-blue.svg";
import warningTriangle from "@src/assets/svg/warning-triangle.svg";

import styles from "./replace-content.module.scss";

import { Spacer16 } from "@components/atoms/spacer-16/spacer-16";
import { Title } from "@components/atoms/title/title";
import { BlueprintInfoGradientWrapper } from "@src/components/molecules/blueprint-info-gradient-wrapper/blueprint-info-gradient-wrapper";
import { GlassyModalHeader } from "@src/components/molecules/glassy-modal-header/glassy-modal-header";
import { HorizontalSeparator } from "@src/components/atoms/horizontal-separator/horizontal-separator";
import { FlexRowContainer } from "@src/components/templates/layouts/flex-row-container/flex-row-container";
import { useReplaceContentHook } from "./use-replace-content-hook";

const cssClassName = "replace-content";

export const ReplaceBlueprintModalContent = () => {
  const {
    selectedBluePrint,
    texts,
    closeModal,
    backToSaveBlueprint,
    continueAndReplaceBlueprint,
    isContinueAndReplaceButtonDisabled,
  } = useReplaceContentHook();

  return (
    <>
      <GlassyModalHeader
        title={texts.subTitle}
        leftIcon={backArrowIcon}
        leftIconFunction={backToSaveBlueprint}
        rightIcon={closeIcon}
        rightIconFunction={closeModal}
      />
      <HorizontalSeparator verticalMargin={16} />
      <div className={styles[`${cssClassName}__existing-blueprint-warning`]}>
        <img src={warningTriangle} alt={texts.warningIconAltText} />
        <p
          className={styles[`${cssClassName}__existing-blueprint-warning-text`]}
        >
          {texts.warningText}
        </p>
      </div>
      <Spacer16 />
      <BlueprintInfoGradientWrapper blueprint={selectedBluePrint} />
      <Spacer16 />
      <Title text={texts.blueprintReplaceQuestion} />
      <Spacer16 />
      <p className={styles[`${cssClassName}__replacement-description-text`]}>
        {texts.firstBlueprintReplacementDescriptionParagraph}
      </p>
      <Spacer16 />
      <p className={styles[`${cssClassName}__replacement-description-text`]}>
        {texts.secondBlueprintReplacementDescriptionParagraph}
      </p>
      <HorizontalSeparator verticalMargin={16} />
      <FlexRowContainer>
        <Button fun={closeModal} text={texts.cancelButton} />
        <Button
          variant={["secondary"]}
          fun={continueAndReplaceBlueprint}
          text={texts.continueButton}
          disabled={isContinueAndReplaceButtonDisabled()}
        />
      </FlexRowContainer>
    </>
  );
};
